import { useLocation } from 'react-router-dom';
import { useAppSelector } from 'store';
import { selectIsSuperUser } from 'store/selectors/me/user';
import {
  SettingsSubLayout,
  type SettingsSubMenuItem,
} from 'containers/SettingsPage/SettingsLayout';

enum SectionSegments {
  Account = 'account',
  Admin = 'admin',
}

const Preferences = () => {
  const isSuperUser = useAppSelector(selectIsSuperUser);
  const { pathname } = useLocation();
  const section = pathname.split('/')[3] as SectionSegments | undefined;
  const selectedSection =
    section && Object.values(SectionSegments).includes(section) ? section : SectionSegments.Account;

  const items: SettingsSubMenuItem[] = [
    {
      label: 'Account',
      iconName: 'circle-user-round',
      to: '/settings/preferences/account',
      isActive: selectedSection === SectionSegments.Account,
    },
    ...(isSuperUser
      ? ([
          {
            label: 'Admin',
            iconName: 'shield-user',
            to: '/settings/preferences/admin',
            isActive: selectedSection === SectionSegments.Admin,
          },
        ] satisfies SettingsSubMenuItem[])
      : []),
  ];

  return <SettingsSubLayout items={items} />;
};

export default Preferences;
